import React from "react";
import style from "./Reason.module.css";
function Reason() {
  return (
    <div className={style.mainContainer}>
      <div className={style.innerContainer}>
        <div className={style.imageContainer}>
          <img
            alt="reason"
            src="https://invozone.com/wp-content/uploads/2020/04/why-iz.svg"
            className={style.mainFig}
          ></img>
        </div>
        <div className={style.detailsDiv}>
          <div className={style.descriptionDiv}>
            <h1 className={style.heading}>
              Why <strong> InvoZone</strong>
            </h1>
            <p className={style.description}>
              With InvoZone you are on road to building a great client
              relationship. We love to code and explore technologies that can
              help improve lives. Our top-notch results are a product of
              marvellous software development techniques. We do this through:
            </p>
          </div>
          <div className={style.listDiv}>
            <li className={style.singleItem}>
              <img
                alt="reason"
                src="https://invozone.com/wp-content/uploads/2020/04/high-performance.svg"
                className={style.listFig}
              ></img>
              <p className={style.listText}>
                High performance and next-level engineering
              </p>
            </li>
            <li className={style.singleItem}>
              <img
                alt="reason"
                src="https://invozone.com/wp-content/uploads/2020/04/high-performance.svg"
                className={style.listFig}
              ></img>
              <p className={style.listText}>
                High performance and next-level engineering
              </p>
            </li>
            <li className={style.singleItem}>
              <img
                alt="reason"
                src="https://invozone.com/wp-content/uploads/2020/04/high-performance.svg"
                className={style.listFig}
              ></img>
              <p className={style.listText}>
                High performance and next-level engineering
              </p>
            </li>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reason;
